export default "__VITE_ASSET__fe48fffe__"